<template>
    <div class="ts-widget" v-if="data && data.reviews && data.reviews.length >= 1 && dataLoaded && data.rating365 > 4">
        <div class="inner">
            <div class="glide-badgex">
                <div class="badgex">
                    <div class="hl" v-html="$attrs.lang1"></div>
                    <div class="txt">
                        <div class="txt-inner">
                            <strong class="rate">{{ data.rating365.toString().replace('.',',') }}</strong>
                            <span class="stars-container">
                                <span class="rate-blank">
                                    <i class="fa fa-star" aria-hidden="true"></i>
                                    <i class="fa fa-star" aria-hidden="true"></i>
                                    <i class="fa fa-star" aria-hidden="true"></i>
                                    <i class="fa fa-star" aria-hidden="true"></i>
                                    <i class="fa fa-star" aria-hidden="true"></i>
                                </span>
                                <span class="rate-full" :style="'width:' + data.rating365 * 20 + '%'">
                                    <i class="fa fa-star" aria-hidden="true"></i>
                                    <i class="fa fa-star" aria-hidden="true"></i>
                                    <i class="fa fa-star" aria-hidden="true"></i>
                                    <i class="fa fa-star" aria-hidden="true"></i>
                                    <i class="fa fa-star" aria-hidden="true"></i>
                                </span>
                            </span>
                        </div>
                        <div class="counts">
                            <span class="total365">{{ data.count365 }} {{ $attrs.lang2 }}</span>
                            <strong class="total">{{ data.overallCount }} {{ $attrs.lang3 }}</strong>
                            <small>{{ $attrs.lang4 }} {{ data.calculatedAt.split('T')[0].split('-')[2] }}.{{ data.calculatedAt.split('T')[0].split('-')[1] }}.{{ data.calculatedAt.split('T')[0].split('-')[0] }}</small>
                        </div>
                    </div>
                    <a class="icon" href="https://www.trustedshops.de/bewertung/info_XC20B8AA148B030F2B75205A3ACEFE5E7.html" target="_blank">
                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfQAAAH0AQMAAADxGE3JAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAADVJREFUeNrtwTEBAAAAwiD7p/ZZDGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOX0AAAEidG8rAAAAAElFTkSuQmCC" data-src="https://cdn02.plentymarkets.com/4ef9772fo0y5/frontend/ts.webp" alt="" class="lazyload">
                    </a>
                    <!-- <div>{{ data.count365 }} <span>Bewertungen <span>(letzte 12 Mon.)</span></span></div>
                    <div>{{ data.overallCount }} Bewertungen (gesamt)</div>
                    <div><a href="https://www.trustedshops.de/bewertung/info_XC20B8AA148B030F2B75205A3ACEFE5E7.html" target="_blank">Stand: {{ data.calculatedAt.split('T')[0].split('-')[2] }}.{{ data.calculatedAt.split('T')[0].split('-')[1] }}.{{ data.calculatedAt.split('T')[0].split('-')[0] }}</a></div> -->
                </div>
                <vue-glide ref="vueglider" @glide:mount-after="update" v-bind="settings">
                    <vue-glide-slide v-for="(review, index) in data.reviews" :key="index">
                        <div class="date-stars">
                            <div class="date">
                                <span v-text="review.name && review.name != '' ? review.name.trim() : $attrs.lang5"></span>
                                {{ review.submittedAt.split('T')[0].split('-')[2] }}.{{ review.submittedAt.split('T')[0].split('-')[1] }}.{{ review.submittedAt.split('T')[0].split('-')[0] }}
                            </div>
                            <div class="stars">
                                <template v-for="index in review.rating * 1"><i class="fa fa-star" aria-hidden="true"></i></template>
                                <template v-for="index in 5 - (review.rating * 1)"><i class="fa fa-star grey" aria-hidden="true"></i></template>
                            </div>
                        </div>
                        <div class="comment">
                            <span v-html="review.comment.trim()"></span>
                        </div>
                    </vue-glide-slide>
                    <template slot="control">
                        <button data-glide-dir="<" data-builder-clickable class="p"><i class="fa fa-angle-left" aria-hidden="true"></i></button>
                        <button data-glide-dir=">" data-builder-clickable class="n"><i class="fa fa-angle-right" aria-hidden="true"></i></button>
                    </template>
                </vue-glide>
            </div>
        </div>
    </div>
</template>

<script>
import { Glide, GlideSlide } from 'vue-glide-js';

// Extract settings to constant (cleaner, reusable)
const CAROUSEL_SETTINGS = {
    perView: 6,
    type: "carousel",
    focusAt: 1,
    gap: 40,
    peek: 0,
    breakpoints: {
        2200: { perView: 5, gap: 40 },
        1800: { perView: 4, gap: 40 },
        1600: { perView: 4, gap: 20 },
        1199: { perView: 3, gap: 20 },
        879: { perView: 2, peek: 0, gap: 20 },
        575: {
            perView: 1,
            gap: 10,
            peek: { before: 50, after: 50 }
        }
    }
};

export default {
    components: {
        [Glide.name]: Glide,
        [GlideSlide.name]: GlideSlide
    },
    data() {
        return {
            data: [],
            dataLoaded: false,
            error: null,
            settings: CAROUSEL_SETTINGS
        }
    },
    mounted() {
        this.fetchRatings();
    },
    methods: {
        async fetchRatings() {
            try {
                // Replace jQuery with native fetch
                const response = await fetch('/rest/cytTrustedShops/ratings');
                if (!response.ok) throw new Error('Failed to fetch ratings');

                this.data = await response.json();
                this.dataLoaded = true;

                // Update glide after data loads
                this.$nextTick(() => {
                    this.$refs.vueglider?.glide?.update();
                });
            } catch (error) {
                console.error('Error fetching ratings:', error);
                this.error = error.message;
            }
        },

        update() {
            // Use nextTick instead of arbitrary timeout
            this.$nextTick(() => {
                this.$refs.vueglider?.glide?.update();
            });
        }
    }
}
</script>
